module.exports = __webpack_public_path__ + "img/about-small.6e372259.jpg";